import Vue from 'vue'
const SET = (state, { key, value }) => {
  state[key] = value
}
const SET_VALUE = (state, { key, valueKey, value }) => {
  Vue.set(state[key], valueKey, value)
}
const UPDATE = (state, { key, value }) => {
  state[key] = { ...state[key], ...value }
}
const MERGE = (state, { key, value = {} }) => {
  Object.keys(value).forEach((valueKey) => {
    Vue.set(state[key], valueKey, value[valueKey])
  })
}
// ARRAY OF OBJECTS
const MERGE_ARRAY = (state, { key, value = [], field = 'id' }) => {
  let concatArray = state[key].concat(value)
  let map = new Map()
  concatArray.forEach((item) => {
    let value = map.has(item[field]) ? { ...map.get(item[field]), ...item } : item
    map.set(item[field], value)
  })
  state[key] = Array.from(map.values())
}
const MERGE_REVERSE_ARRAY = (state, { key, value, field = 'id' }) => {
  let concatArray = value.concat(state[key])
  let map = new Map()
  concatArray.forEach((item) => {
    let value = map.has(item[field]) ? { ...map.get(item[field]), ...item } : item
    map.set(item[field], value)
  })
  state[key] = Array.from(map.values())
}
const REPLACE_ARRAY_ITEM = (state, { key, value, field = 'id' }) => {
  let arrayIndex = state[key].findIndex((item) => item[field] === value[field])
  if (arrayIndex !== -1) {
    state[key].splice(arrayIndex, 1, value)
  }
}
const PUSH = (state, { key, value }) => {
  state[key].push(value)
}
/**
 * @desc delete item from array
 * @param state { Vuex.State } - state of store
 * @param key { String } - key of data state
 * @param value { Object } - item of array
 * @param id { String } - field of item (default => id)
 */
const DELETE_ITEM_ARRAY = (state, { key, value, id = 'id' }) => {
  state[key] = state[key].filter(item => item[id] !== value[id])
}
const MERGE_ITEM_ARRAY = (state, { key, value, field = 'id' }) => {
  let itemIndex = state[key].findIndex((item) => item[field] === value[field])
  if (itemIndex !== -1) {
    Vue.set(state[key], itemIndex, { ...state[key][itemIndex], ...value })
  }
}
export {
  SET,
  SET_VALUE,
  UPDATE,
  MERGE,
  MERGE_ARRAY,
  REPLACE_ARRAY_ITEM,
  MERGE_REVERSE_ARRAY,
  PUSH,
  MERGE_ITEM_ARRAY,
  DELETE_ITEM_ARRAY
}
